import _ from 'lodash';
import React from 'react';
import {requestBlob} from 'sdk';
import loadImage from 'blueimp-load-image';

import pdfImage from './assets/pdf.svg';

/*
  The purpose of this component is to display image with right orientation.
  As the `loadImage` from `blueimp-load-image` library works only with blobs, we
  need to request the image in blob format (using `requestBlob`) and then
  render the image with the right orientation.
*/

const PDF = 'application/pdf';

function getBase64URI(imageSrc, callback) {
  requestBlob(imageSrc)
    .then(response => {
      callback(response.data);
    })
    .catch(error => console.log(error));
}

class ExifImage extends React.Component<any> {
  state = {
    preview: null
  };

  loadImage = image => {
    if (image.type === PDF) {
      return this.setState({preview: pdfImage});
    }

    let loadImageOptions: any = {
      canvas: true
    };

    loadImage.parseMetaData(image, data => {
      if (data.exif && data.exif.get('Orientation')) {
        loadImageOptions = {
          canvas: true,
          orientation: data.exif.get('Orientation')
        };
      }

      loadImage(
        image,
        canvas => {
          this.setState({
            preview: canvas.toDataURL(image.type)
          });
        },
        loadImageOptions
      );
    });
  };

  componentDidMount() {
    getBase64URI(this.props.src, this.loadImage);
  }

  componentDidUpdate(prevProps) {
    if (prevProps.src != this.props.src) {
      getBase64URI(this.props.src, this.loadImage);
    }
  }

  render() {
    const {preview} = this.state;

    return (
      <React.Fragment>
        {preview && <img src={preview} alt={this.props.alt} />}
      </React.Fragment>
    );
  }
}

export default ExifImage;
